function toDecimal2(value) {
  return Math.round(value * 100) / 100;
}

function toDecimal3(value) {
  return Math.round(value * 1000) / 1000;
}

function toDecimal4(value) {
  return Math.round(value * 10000) / 10000;
}

function toDecimal5(value) {
  return Math.round(value * 100000) / 100000;
}

function toDecimal6(value) {
  return Math.round(value * 1000000) / 1000000;
}

function toDecimal7(value) {
  return Math.round(value * 10000000) / 10000000;
}

function toDecimal8(value) {
  return Math.round(value * 100000000) / 100000000;
}

function toDecimal9(value) {
  return Math.round(value * 1000000000) / 1000000000;
}

function toDecimal10(value) {
  return Math.round(value * 10000000000) / 10000000000;
}

function toDecimal11(value) {
  return Math.round(value * 100000000000) / 100000000000;
}

function toDecimal12(value) {
  return Math.round(value * 1000000000000) / 1000000000000;
}

export {
  toDecimal2,
  toDecimal3,
  toDecimal4,
  toDecimal5,
  toDecimal6,
  toDecimal7,
  toDecimal8,
  toDecimal9,
  toDecimal10,
  toDecimal11,
  toDecimal12
};
